export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  chiSono: "nav-chi-sono",
  servizi: "nav-servizi",
  portfolio: "nav-portfolio",
  prenota: "nav-prenota",
  contatti: "nav-contatti",
  admin: "nav-admin",
  mobileToggle: "nav-mobile-toggle",
};

export const HOME = {
  hero: "home-hero",
  ctaPrenota: "home-cta-prenota",
  ctaPortfolio: "home-cta-portfolio",
  featuredGrid: "home-featured-grid",
  emergentLink: "home-emergent-link",
};

export const PORTFOLIO = {
  grid: "portfolio-grid",
  filter: (cat) => `portfolio-filter-${cat}`,
  item: (id) => `portfolio-item-${id}`,
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const BOOKING = {
  form: "booking-form",
  name: "booking-name",
  email: "booking-email",
  phone: "booking-phone",
  date: "booking-date",
  slot: (t) => `booking-slot-${t}`,
  type: "booking-type",
  notes: "booking-notes",
  submit: "booking-submit",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabPortfolio: "admin-tab-portfolio",
  tabBookings: "admin-tab-bookings",
  tabContacts: "admin-tab-contacts",
  newProject: "admin-new-project",
  saveProject: "admin-save-project",
  deleteProject: (id) => `admin-delete-project-${id}`,
  editProject: (id) => `admin-edit-project-${id}`,
};
